<template>
  <v-layout>
    <v-flex>
      <v-combobox
        v-model="selectedValue"
        :items="affiliations"
        :hide-no-data="!search"
        :search-input.sync="search"
        small-chips
        outlined
        dense
        :label="$t('message.affiliation')"
        @input="event => { $emit('input', event) }"
      >
        <template slot="no-data">
          <v-list-item>
            <span class="subheading">{{ $t('message.click_enter_add_new') }}: </span>
            <v-chip
              label
              small
            >
              {{ search }}
            </v-chip>
          </v-list-item>
        </template>
      </v-combobox>
    </v-flex>
  </v-layout>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      selectedValue: null,
      affiliations: [],
      loading: false,
      items: [],
      search: null
    };
  },
  created() {
    Api()
      .get(
        "academies/distinct/local_affiliations"
      )
      .then(response => {
        if(response.data)
          this.affiliations = response.data.sort();
      })
      .catch(e => {
        this.loading = false;
        if(e)
          this.showAlert("error", "Oops!", this.$t('message.error_generic'));
      });
  },
  mounted(){
    this.selectedValue = this.value
  },
  props: {
    value: null,
    showIcon: null
  },
  watch: {
    value: {
      handler: function(newValue) {
        this.selectedValue = newValue;
      }
    }
  },
  methods: {
    async querySelections(v) {
      this.loading = true;
      if (this.affiliations.length == 0) {
        var r = await Api.get("academies/distinct/local_affiliations");
        if(r.data)
          this.affiliations = r.data.sort();
      }
      this.items = this.affiliations.filter(e => {
        return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
      });
      this.loading = false;
    }
  }
};
</script>

<style scoped>
</style>